"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserInfo = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getUserInfo = exports.getUserInfo = function getUserInfo() {
  var loggedInUserCookie = _jsCookie["default"].get("user");
  var userInfo = loggedInUserCookie ? JSON.parse(loggedInUserCookie) : null;
  if (!userInfo) {
    return {
      userId: "NO_ID",
      userName: "NO_USER_NAME",
      nameUser: "NO_NAME"
    };
  }
  var userId = String(userInfo.id);
  var nameUser = userInfo.userAttributes.name;
  var userName = userInfo.username;
  return {
    userId: userId,
    userName: userName,
    nameUser: nameUser
  };
};